type SyncCallback = (sessionId: string, messages: any[], activeTask?: any) => void;

let broadcastChannel: BroadcastChannel | null = null;
let storageListenerActive = false;

// P2-D8: 每个会话最近一次本地写入 messages 的时间戳（按 sessionId）。
// 由 markLocalUpdate 在 finalize/polling completed/setMessages 等本地写入路径调用。
// 收到 timestamp 早于 lastLocalUpdateAt 的跨标签页广播时直接丢弃，避免旧 messages 覆盖。
const lastLocalUpdateAt = new Map<string, number>();

/** P2-D8: 标记本标签页本地写入了某会话的 messages（更新 fresh 时间戳） */
export function markLocalUpdate(sessionId: string): void {
  if (!sessionId) return;
  lastLocalUpdateAt.set(sessionId, Date.now());
}

/** P2-D8: 检查广播是否滞后于本标签页的本地写入 */
function isBroadcastStale(sessionId: string, broadcastTs: number | undefined): boolean {
  if (!sessionId) return false;
  const localTs = lastLocalUpdateAt.get(sessionId);
  if (!localTs) return false;
  // 广播没有 timestamp（旧版本兼容）或 timestamp 早于本地最近写入 → 视为滞后
  if (!broadcastTs || broadcastTs < localTs) return true;
  return false;
}

export function initCrossTabSync(onSync: SyncCallback): void {
  try {
    broadcastChannel = new BroadcastChannel('bongai-agent-sync');
    broadcastChannel.onmessage = (event) => {
      const { type, sessionId, messages, activeTask, timestamp } = event.data || {};
      if (type === 'agent-update' && sessionId) {
        // P2-D8: 过滤滞后广播——本标签页本地写入比此广播更新时直接丢弃
        if (isBroadcastStale(sessionId, timestamp)) {
          return;
        }
        // ASK-GAP-7: 透传 activeTask 字段，让接收方恢复询问态
        onSync(sessionId, messages, activeTask);
      }
    };
  } catch {}

  if (!storageListenerActive) {
    try {
      window.addEventListener('storage', (e) => {
        if (e.key === 'bongai_agent_broadcast' && e.newValue) {
          try {
            const data = JSON.parse(e.newValue);
            if (data.type === 'agent-update' && data.sessionId) {
              // P2-D8: 同样的滞后过滤
              if (isBroadcastStale(data.sessionId, data.timestamp)) {
                return;
              }
              // ASK-GAP-7: 透传 activeTask 字段
              onSync(data.sessionId, data.messages, data.activeTask);
            }
          } catch {}
        }
      });
      storageListenerActive = true;
    } catch {}
  }
}

export function notifyOtherTabs(sessionId: string, messages: any[], activeTask?: any): void {
  try {
    const timestamp = Date.now();
    // P2-D8: 广播方也更新本标签页的本地写入时间戳，避免本标签页 finalize 后立即收到
    // 自己触发的回环广播（BroadcastChannel 不回环，但 storage 事件在某些浏览器会触发）
    markLocalUpdate(sessionId);
    if (broadcastChannel) {
      // ASK-GAP-7: 追加 activeTask 字段（含 askData），让其他 tab 恢复询问态
      broadcastChannel.postMessage({ type: 'agent-update', sessionId, messages, activeTask, timestamp });
    } else {
      localStorage.setItem('bongai_agent_broadcast', JSON.stringify({
        type: 'agent-update', sessionId, messages, activeTask, timestamp
      }));
      localStorage.removeItem('bongai_agent_broadcast');
    }
  } catch {}
}
